<template>
    <div name="Agreement">
        <h2>[유전자검사 동의]</h2>
        솔닥의 서비스를 이용해주셔서 감사합니다.<br>
        본인은 「생명윤리 및 안전에 관한 법률」 제51조 및 같은 법 시행규칙 제51조에 따라 아래와 같이 유전자검사의 목적과 결과의 함의와 한계 등에 대하여 충분한 설명을 들어 이해하였으므로 아래와 같이 본인에 대한 유전자검사에 자발적인 의사로 동의합니다.<br>

        <h3>[검사대상자]</h3>
        검사대상자 정보에는 성명, 생년월일, 주소, 전화번호, 성별 정보가 필요합니다.<br>
        유전자 검사 동의 후 정보 입력 단계에서 작성한 성명, 생년월일, 주소, 전화번호, 성별 정보가 동의서에 자동으로 반영됩니다.<br>

        <h3>[법정대리인*]</h3>
        * 법정대리인 정보는 검사대상자가 미성년자인 경우 등의 사유로 필요하며 이때 성명, 검사 대상자와의 관계, 전화번호를 입력해야 합니다.<br>

        <h3>[검사 안내]</h3>
        - 유전자검사기관 : (주)테라젠헬스 (문의번호 : 1522-2375)<br>
        - 유전자검사의 목적 : 질병 예측을 위한 유전자 검사<br>
        - 검사 항목 : {{product_name}}<br>
        - 의뢰기관<br>
        의료기관명 :  {{hospital_name}}<br>
        의뢰의사 : {{hospital_name}} 의료진<br>

        <h3>[유의사항]</h3>
        1. 이 유전자검사의 결과는 10년간 보존되며, 법 제52조 제2항에 따라 본인이나 법정대리인이 요청하는 경우 열람할 수 있습니다.<br>
        2. 유전자검사기관의 폐업 등 검사대상물 등을 보존할 수 없는 경우에는 검사대상물 및 검사동의서, 개인정보가 포함된 유전정보에 관한 기록물과 그 관리대장은 법에서 정한 절차에 따라 폐기됩니다. 다만, 보존 중에 검사대상자가 다른 검사기관이나 질병관리청으로 이관을 요청하는 경우에는 이관할 수 있습니다.<br>
        3. 유전자검사기관은 동의 받은 목적 외 검사대상물 및 관련 정보를 보존·이용 또는 제공할 수 없습 니다. 검사 후 남은 검사대상물을 연구목적으로 이용하기 위해서는 연구목적 및 분야, 제공되는 정 보의 범위 등에 관한 구체적인 설명을 충분히 듣고 인체유래물연구 또는 허가받은 인체유래물은행에 기증하는 것에 동의하는 경우에 별지 제34호의 인체유래물연구 동의서 또는 별지 제41호의 인체유래물등의 기증 동의서를 추가로 작성하여야 합니다.<br>
        4. 유전자검사기관 또는 검사를 의뢰하는 의료기관은 검사대상자에게 시행하려는 유전자검사의 목적 및 검사항목, 검사대상물의 관리방법, 동의의 철회 방법, 검사대상자의 권리 및 정보보호, 유전자검사기관의 휴업·폐업 시 검사대상물 및 관련 기록의 폐기 또는 이관에 관한 사항, 유전자검사 결과기록의 보존기간 및 관리방법, 유전자검사결과의 한계 등을 충분하게 설명해야 합니다.<br>

    </div>
</template>

<script>
export default {
    name: 'Agreement',
    data: function()
    {
        return {
            product_name: '',
            hospital_name: ''
        }
    },
    mounted: function()
    {
        this.product_name = this.$route.query.product_name;
        this.hospital_name = this.$route.query.hospital_name;
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/genetic/Agreement.vue